import { VERIFICATION_SERVER_URL, VERIFICATION_COMPLETE_ROUTE } from '../shared/consts';
import { addLogLine } from './log';
import { makeGetRequestHandleResponse } from './request';
import Mdn from '../shared/mdn';
import { encryptParams } from '../shared/paramsEncoding';

export async function notifyCompletion(userId: string, siteId: string, extVersion: string, consentId: string, consentTimestamp: string, mdnObj: Mdn, sessionId: string, supplierType: number, supplierResponseObj: object) : Promise<object | undefined> {
    addLogLine("notifyCompletion, suppliedMDN: " + mdnObj + ' sessionId: ' + sessionId + ' supplierType: ' + supplierType);
    const encryptedParamsStr = encryptParams({ userId, siteId, extVersion, consentId, consentTimestamp, mdn: mdnObj.getFullFormattedMdn(), sessionId, supplierResponseJson: JSON.stringify(supplierResponseObj)});
    if (!encryptedParamsStr) {
        const errMsg = 'Failed to encrypt params';
        addLogLine(errMsg);
        throw new Error(errMsg);
    }
    const encryptedParamQuery = new URLSearchParams({p: encryptedParamsStr});
    const getURL = VERIFICATION_SERVER_URL + VERIFICATION_COMPLETE_ROUTE + '/' + supplierType + '?' + encryptedParamQuery.toString();
    // TODO consider changing the integration type to use redirecturl to the response doesn't reach the user
    const fetchParsedResponse = await makeGetRequestHandleResponse(getURL);
    if (!fetchParsedResponse.success) {
        addLogLine('Failed to notify server - response error details -  ' + fetchParsedResponse.errorResponseStr);
        return;
    }
    return fetchParsedResponse.successResponseObj;
    
}